export default "__VITE_ASSET__NLYJl8kb__"